import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Traductions françaises
const fr = {
  translation: {
    // Navigation
    nav: {
      home: "Accueil",
      indicators: "Indicateurs",
      free: "Gratuit",
      resources: "Ressources",
      ninjatrader: "NinjaTrader",
      cart: "Panier",
      login: "Connexion",
      register: "S'inscrire",
      profile: "Profil",
      logout: "Déconnexion"
    },
    // Page d'accueil
    home: {
      hero: {
        title: "Indicateurs de Trading Professionnels",
        subtitle: "Développés par des traders, pour des traders",
        description: "Des indicateurs NinjaTrader 8 pour l'analyse de volume, le VWAP et les niveaux de session — installation guidée et support inclus.",
        cta: "Explorer nos Produits",
        demo: "Voir la Démo"
      },
      features: {
        title: "Pourquoi choisir Alturion ?",
        precision: {
          title: "Haute Précision",
          description: "Nos indicateurs sont développés avec une attention méticuleuse aux détails pour garantir des signaux fiables."
        },
        quality: {
          title: "Qualité Premium",
          description: "Chaque indicateur est testé rigoureusement avant sa mise sur le marché."
        },
        support: {
          title: "Support Dédié",
          description: "Notre équipe d'experts est là pour vous accompagner dans l'utilisation de nos outils."
        }
      },
      products: {
        title: "Nos Indicateurs Populaires",
        viewAll: "Voir tous les indicateurs",
        addToCart: "Ajouter au panier",
        free: "GRATUIT",
        reviews: "avis",
        viewProduct: "Voir le Produit"
      },
      comingSoon: {
        index: "Roadmap",
        title: "Bientôt disponibles",
        subtitle: "Prochains outils en préparation pour élargir votre arsenal NinjaTrader.",
        badge: "Coming soon",
        ctaTitle: "Soyez prévenu au lancement",
        ctaSubtitle: "Un email suffira. On vous écrira uniquement pour ces sorties.",
        placeholder: "Votre adresse email",
        submit: "Me prévenir",
        loading: "Envoi...",
        success: "Merci ! On vous préviendra dès que ces indicateurs seront disponibles.",
        error: "Erreur lors de l'inscription.",
        validation: {
          required: "Email requis",
          error: "Format d'email invalide"
        },
        items: {
          footprint: {
            name: "Footprint",
            teaser: "Lecture tick-by-tick des agressions acheteur et vendeur sur chaque niveau de prix."
          },
          "cumulative-delta": {
            name: "Cumulative Delta",
            teaser: "Flux acheteur/vendeur cumulé pour visualiser le déséquilibre dans le temps."
          },
          "delta-profile": {
            name: "Delta Profile",
            teaser: "Distribution du delta par prix pour repérer où le flux s'est vraiment battu."
          },
          "big-trades": {
            name: "Big Trades",
            teaser: "Les gros prints mis en évidence pour voir où les tailles importantes sont passées."
          },
          dashboard: {
            name: "Dashboard",
            teaser: "Vue d'ensemble multi-outils pour suivre vos indicateurs Alturion en un coup d'œil."
          }
        }
      },
      tradingStyles: {
        title: "Choisissez Votre Style de Trading",
        subtitle: "Des outils sophistiqués pour chaque approche de trading",
        volumeAnalysis: {
          title: "Analyse de Volume",
          description: "Utilisez la puissance de l'analyse des volumes pour identifier les véritables zones d'intérêt."
        },
        sessionLevels: {
          title: "Niveaux de Session", 
          description: "Exploitez les niveaux clés des différentes sessions de trading pour anticiper les mouvements."
        },
        intradayTrading: {
          title: "Trading Intraday",
          description: "Obtenez des signaux précis et réactifs pour vos opérations intraday et scalping."
        }
      },
      cta: {
        title: "Prêt à Transformer Votre Trading ?",
        subtitle: "Essayez nos indicateurs pendant 7 jours. Installation guidée, mises à jour et support inclus.",
        button: "Découvrir Nos Indicateurs"
      },
      guaranteePopup: {
        title: "🎯 Offre Spéciale",
        subtitle: "Essayez nos indicateurs sans risque",
        guarantee: "7 jours satisfait ou remboursé",
        description: "Testez nos indicateurs premium pendant 7 jours complets. Si vous n'êtes pas entièrement satisfait, nous vous remboursons intégralement.",
        benefits: [
          "✅ Remboursement intégral sous 7 jours",
          "✅ Support technique inclus",
          "✅ Installation guidée",
          "✅ Mises à jour gratuites"
        ],
        cta: "Découvrir nos Indicateurs",
        close: "Fermer",
        limitedTime: "Offre limitée dans le temps"
      },
      testimonials: {
        title: "Ce Que Disent Nos Clients",
        items: [
          {
            quote: "Les indicateurs d'Alturion ont complètement transformé mon approche du trading. Le Volume Profile m'a permis d'identifier les zones clés avec une précision incroyable.",
            author: "Thomas L.",
            role: "Day Trader"
          },
          {
            quote: "L'indicateur VWAP Premium est devenu un outil indispensable dans mon arsenal. Les bandes de déviation sont parfaites pour repérer les opportunités de scalping.",
            author: "Sophie M.",
            role: "Trader Institutionnel"
          },
          {
            quote: "Asian Session Levels m'a donné un avantage significatif pour préparer mes trades de la session européenne. Service client impeccable!",
            author: "Marc D.",
            role: "Swing Trader"
          }
        ]
      },
      contact: {
        title: "Contactez-nous",
        description: "Une question ? Besoin d'aide ? Notre équipe est là pour vous.",
        name: "Nom",
        email: "Email",
        subject: "Sujet",
        message: "Message",
        send: "Envoyer le message",
        sendButton: "Envoyer",
        success: "Message envoyé avec succès !",
        error: "Erreur lors de l'envoi du message.",
        placeholders: {
          name: "Votre nom",
          email: "Votre email",
          subject: "Sujet",
          message: "Votre message"
        },
        validation: {
          required: "Tous les champs sont requis",
          error: "Erreur lors de l'envoi du message. Veuillez réessayer plus tard."
        },
        loading: "Envoi en cours..."
      },
      newsletter: {
        title: "Restez informé de nos innovations",
        description: "Abonnez-vous à notre newsletter pour recevoir nos dernières actualités et conseils en matière de trading.",
        placeholder: "Votre adresse email",
        subscribe: "S'abonner",
        success: "Inscription réussie !",
        error: "Erreur lors de l'inscription.",
        loading: "Abonnement...",
        validation: {
          required: "Email requis",
          error: "Format d'email invalide"
        }
      }
    },
    // Page indicateurs
    indicators: {
      title: "Nos Indicateurs",
      subtitle: "Découvrez notre gamme complète d'indicateurs techniques",
      categories: {
        all: "Tous",
        volume: "Volume",
        levels: "Niveaux",
        analysis: "Analyse"
      },
      sortBy: "Trier par",
      sort: {
        name: "Nom",
        price: "Prix",
        rating: "Note"
      },
      noProducts: "Aucun produit trouvé.",
      addToCart: "Ajouter au panier",
      free: "GRATUIT"
    },
    // Page produit
    product: {
      addToCart: "Ajouter au panier",
      backToProducts: "Retour aux indicateurs",
      price: "Prix",
      free: "GRATUIT",
      category: "Catégorie",
      compatibility: "Compatibilité",
      rating: "Note",
      reviews: "avis",
      features: "Fonctionnalités",
      description: "Description détaillée",
      images: "Images",
      outOfStock: "Rupture de stock",
      quantity: "Quantité",
      selectQuantity: "Sélectionner la quantité"
    },
    cookieBanner: {
      title: "Nous respectons votre vie privée",
      body: "Ce site utilise des cookies pour améliorer votre expérience et nos services. En poursuivant votre navigation, vous acceptez l'utilisation de cookies conformément à notre",
      policy: "politique de cookies",
      decline: "Refuser",
      customize: "Personnaliser",
      accept: "Accepter"
    },
    // Panier
    cart: {
      title: "Panier d'achat",
      empty: "Votre panier est vide",
      backToShopping: "← Continuer les achats",
      item: "Article",
      quantity: "Quantité",
      price: "Prix",
      total: "Total",
      subtotal: "Sous-total",
      checkout: "Procéder au paiement",
      remove: "Supprimer",
      summary: "Résumé de la commande",
      items: "Articles"
    },
    // Checkout
    checkout: {
      orderSummary: "Résumé de votre commande",
      quantity: "Quantité",
      total: "Total",
      free: "GRATUIT",
      freeProducts: "Produits gratuits - Aucun paiement requis",
      confirmFreeOrder: "Confirmer la commande gratuite",
      pay: "Payer {{price}}",
      securePayment: "Paiement sécurisé",
      processing: {
        title: "Traitement en cours...",
        verifying: "Vérification des informations...",
        validating: "Validation de la commande...",
        processing: "Traitement du paiement...",
        finalizing: "Finalisation...",
        completed: "terminé"
      }
    },
    // Page de succès checkout
    checkoutSuccess: {
      paymentAccepted: "Paiement accepté !",
      thankYou: "Merci pour votre commande",
      orderProcessed: "Votre commande a été traitée avec succès.",
      orderNumber: "Numéro de commande",
      indicatorsAvailable: "Vos indicateurs sont maintenant disponibles dans votre espace client.",
      emailSent: "Une confirmation vous a été envoyée par email.",
      findOrder: {
        title: "Retrouvez votre commande",
        description: "dans l'onglet \"Mes Commandes\" de votre profil."
      },
      redirecting: "Redirection vers vos commandes dans {{seconds}} secondes...",
      stayOnPage: "Rester sur cette page",
      viewOrders: "Voir mes commandes",
      verifying: "Vérification de votre paiement...",
      backToCart: "Retourner au panier",
      errors: {
        invalidId: "Identifiant de session ou de commande invalide.",
        unauthorized: "Accès non autorisé.",
        timeout: "Le délai de vérification du paiement est dépassé. Veuillez vérifier votre profil pour le statut de la commande.",
        orderVerification: "Une erreur est survenue lors de la vérification de la commande.",
        paymentVerification: "Impossible de vérifier le statut du paiement.",
        general: "Une erreur est survenue lors de la vérification du paiement."
      }
    },
    // Authentification
    auth: {
      login: {
        title: "Connexion",
        email: "Adresse email",
        password: "Mot de passe",
        submit: "Se connecter",
        noAccount: "Nouveau client ?",
        register: "S'inscrire"
      },
      register: {
        title: "Créer un compte",
        name: "Nom complet",
        email: "Adresse email",
        password: "Mot de passe",
        confirmPassword: "Confirmer le mot de passe",
        submit: "S'inscrire",
        hasAccount: "Déjà un compte ?",
        login: "Se connecter",
        passwordMismatch: "Les mots de passe ne correspondent pas"
      }
    },
    // NinjaTrader
    ninjatrader: {
      title: "Notre Plateforme de Trading Recommandée",
      subtitle: "La plateforme de trading professionnelle",
      description: "NinjaTrader® est notre plateforme de trading n°1, préférée par les traders du monde entier, y compris nos clients.",
      downloadTitle: "Téléchargez NinjaTrader",
      downloadSubtitle: "& recevez immédiatement un accès GRATUIT à :",
      features: [
        "Trading simulé avec données futures en temps réel",
        "Graphiques avancés avec possibilité de trader directement depuis vos charts",
        "Moteur de backtesting haute performance pour analyser vos stratégies sur données historiques",
        "Gestion avancée des trades avec ordres stop, target et trailing stops automatiques"
      ],
      platformDescription: "La plateforme de trading primée de NinjaTrader est régulièrement élue leader de l'industrie par la communauté des traders. Avec des milliers d'applications et d'add-ons pour une personnalisation illimitée, NinjaTrader est utilisé par plus de 1,9 million de traders pour l'analyse avancée des marchés, les graphiques professionnels et l'exécution rapide des ordres.",
      kinetick: {
        title: "Notre Service de Données de Marché Recommandé",
        description1: "Kinetick® fournit des données de marché fiables, rapides et rentables pour aider à égaliser les chances des traders actifs. Profitez de cotations en temps réel non filtrées pour les actions, futures et forex qui dépassent les attentes des traders les plus exigeants, comme nous !",
        description2: "Commencez avec des données historiques de fin de journée GRATUITES directement via la plateforme NinjaTrader et découvrez comment vous pouvez réduire significativement les frais d'échange CME Group Globex sur les données en temps réel avec Kinetick."
      },
      cta: {
        download: "COMMENCER GRATUITEMENT",
        data: "COMMENCER AVEC LES DONNÉES EOD GRATUITES"
      }
    },
    // Footer
    footer: {
      company: "Entreprise",
      products: "Produits",
      support: "Support",
      legal: "Légal",
      navigation: "Navigation",
      description: "Nous développons des indicateurs de trading innovants pour NinjaTrader 8, conçus pour optimiser vos stratégies et maximiser vos performances sur les marchés financiers.",
      links: {
        about: "À propos",
        contact: "Contact",
        indicators: "Indicateurs",
        ninjatrader: "NinjaTrader",
        help: "Aide",
        faq: "FAQ",
        privacy: "Politique de confidentialité",
        terms: "Conditions d'utilisation",
        cookies: "Politique des cookies",
        refund: "Politique de remboursement",
        legalNotice: "Mentions légales"
      },
      copyright: "© 2024 Alturion. Tous droits réservés.",
      disclaimer: "Les performances passées ne préjugent pas des performances futures. Le trading comporte des risques de perte."
    },
    // Profil utilisateur
    profile: {
      title: "Mon Profil",
      tabs: {
        profile: "Mon Profil",
        indicators: "Mes Indicateurs",
        orders: "Mes Commandes"
      },
      account: {
        title: "Informations du compte",
        name: "Nom",
        email: "Email",
        editButton: "Modifier le profil",
        editTitle: "Modifier mon profil"
      },
      billing: {
        title: "Informations de facturation",
        description: "Ces informations seront utilisées pour générer vos factures.",
        name: "Nom / Entreprise",
        address: "Adresse",
        zipCode: "Code Postal", 
        city: "Ville",
        country: "Pays",
        vat: "Numéro de TVA",
        notProvided: "Non renseigné",
        notProvidedFeminine: "Non renseignée",
        updateButton: "Mettre à jour les informations de facturation"
      },
      messages: {
        thankYou: "Merci pour votre achat !",
        orderSuccess: "Votre commande a été traitée avec succès. Vous pouvez maintenant accéder à vos indicateurs.",
        profileUpdated: "Profil mis à jour avec succès !",
        close: "Fermer"
      },
      form: {
        name: "Nom",
        email: "Adresse Email",
        currentPassword: "Mot de passe actuel",
        newPassword: "Nouveau mot de passe",
        confirmPassword: "Confirmer le mot de passe",
        changePassword: "Changer le mot de passe",
        passwordNote: "Laissez ces champs vides si vous ne souhaitez pas modifier votre mot de passe",
        updating: "Mise à jour...",
        update: "Mettre à jour",
        cancel: "Annuler",
        placeholders: {
          name: "Entrez votre nom",
          email: "Entrez votre email",
          currentPassword: "Entrez votre mot de passe actuel",
          newPassword: "Entrez un nouveau mot de passe",
          confirmPassword: "Confirmez votre nouveau mot de passe"
        },
        errors: {
          passwordMismatch: "Les mots de passe ne correspondent pas",
          oldPasswordRequired: "Veuillez entrer votre ancien mot de passe pour le modifier",
          emailChanged: "Votre email a été modifié. Voulez-vous vous reconnecter avec les nouvelles informations?"
        }
      },
      billingForm: {
        title: "Informations de facturation",
        success: "Vos informations de facturation ont été mises à jour avec succès.",
        error: "Une erreur est survenue. Veuillez réessayer.",
        fields: {
          name: "Nom / Entreprise",
          address: "Adresse",
          zipCode: "Code Postal",
          city: "Ville",
          country: "Pays",
          vat: "Numéro de TVA (optionnel)"
        },
        placeholders: {
          name: "Entrez votre nom ou celui de votre entreprise",
          address: "Entrez votre adresse",
          zipCode: "Entrez votre code postal",
          city: "Entrez votre ville",
          country: "Entrez votre pays",
          vat: "Entrez votre numéro de TVA si applicable"
        },
        updating: "Mise à jour...",
        update: "Mettre à jour",
        cancel: "Annuler",
        close: "Fermer"
      },
      indicators: {
        title: "Mes Indicateurs",
        installGuide: {
          title: "Guide d'installation rapide",
          steps: [
            "Téléchargez le fichier ZIP après votre achat",
            "Ouvrez NinjaTrader 8",
            "Allez dans Tools > Import > NinjaScript Add-On...",
            "Sélectionnez le fichier ZIP téléchargé",
            "Redémarrez NinjaTrader 8"
          ],
          requirements: "Configuration requise :",
          requirementsList: "NinjaTrader 8, Windows 10/11 64-bit, 4 GB RAM",
          support: "Besoin d'aide ?",
          contactSupport: "Contactez notre support"
        },
        licenseGuide: {
          title: "Guide d'activation de licence rapide",
          steps: [
            "Ouvrez NinjaTrader Control Center",
            "Cliquez sur Help > \"3rd party licensing\"",
            "Dans \"Vendor Name\", entrez : Alturion",
            "Dans \"User Defined ID\", entrez votre nom ou identifiant",
            "Cliquez sur \"Submit\" une seule fois",
            "Copiez le \"Signed Machine ID\" généré",
            "Cliquez sur 'Obtenir ma licence' pour votre indicateur et collez votre Signed Machine ID"
          ],
          requirements: "⚠️ Important :",
          requirementsList: "Les Machine IDs non signés ne sont pas acceptés",
          support: "Problème avec votre licence ?",
          contactSupport: "Contactez notre support"
        },
        purchased: {
          purchasedOn: "Acheté le",
          download: "Télécharger",
          getLicense: "Obtenir ma licence",
          tagLicenseRequired: "Licence requise",
          tagNoLicense: "Sans activation",
          noActivationNeeded: "Pas d'activation nécessaire",
          noIndicators: "Vous n'avez pas encore d'indicateurs.",
          discoverIndicators: "Découvrir nos indicateurs"
        },
        licenseModal: {
          title: "Activer votre licence",
          productInfo: "Pour activer votre licence, nous avons besoin de quelques informations",
          instructions: {
            title: "Comment générer votre Machine ID signé NinjaTrader ?",
            steps: [
              "Ouvrez NinjaTrader Control Center",
              "Cliquez sur Help > \"3rd party licensing\"",
              "Dans \"Vendor Name\", saisissez : Alturion",
              "Dans \"User Defined ID\", saisissez votre nom ou identifiant",
              "Cliquez sur \"Submit\" une seule fois",
              "Copiez le \"Signed Machine ID\" généré"
            ],
            screenshotAlt: "Fenêtre NinjaTrader « 3rd Party Licensing » : Vendor name Alturion, User defined ID, puis Submit",
            warning: "Les Machine IDs non signés ne sont pas acceptés"
          },
          form: {
            label: "Machine ID Signé-Nom *",
            placeholder: "Ex: ABC123DEF456-JeanDupont",
            description: "Le Machine ID signé généré par NinjaTrader suivi de votre nom",
            formatRequired: "Format obligatoire : MachineID-Nom (le tiret est requis)",
            cancel: "Annuler",
            submit: "Envoyer",
            sending: "Envoi en cours..."
          },
          validation: {
            required: "Le champ Machine ID-Nom est requis",
            missingDash: "Le format doit être \"MachineID-Nom\". Le tiret (-) est obligatoire pour séparer le Machine ID de votre nom.",
            missingName: "Le format doit être \"MachineID-Nom\". Veuillez ajouter votre nom ou pseudo après le tiret.",
            emptyMachineId: "La partie Machine ID (avant le tiret) ne peut pas être vide.",
            emptyName: "La partie nom (après le tiret) ne peut pas être vide. Veuillez ajouter votre nom ou pseudo.",
            shortMachineId: "Le Machine ID semble trop court. Assurez-vous d'utiliser le \"Signed Machine ID\" généré par NinjaTrader.",
            shortName: "Le nom doit contenir au moins 2 caractères.",
            duplicate: "Ce Machine ID-Nom est déjà utilisé pour ce produit. Veuillez en choisir un différent."
          },
          footer: "Vos informations sont sécurisées et utilisées uniquement pour l'activation de licence."
        }
      },
      orders: {
        title: "Mes Commandes",
        noOrders: "Vous n'avez pas encore de commandes",
        columns: {
          id: "ID",
          date: "Date",
          total: "Total",
          paid: "Payé",
          items: "Articles",
          invoice: "Facture"
        },
        paid: "Date payée",
        notPaid: "Non payé",
        generating: "Génération...",
        unknownDate: "Date inconnue",
        invoiceSuccess: "Facture téléchargée avec succès !"
      }
    },
    // Page Ressources
    resources: {
      title: "Ressources",
      subtitle: "Découvrez nos partenaires de confiance et accédez à des ressources exclusives pour optimiser votre trading",
      propFirms: {
        title: "Notre sélection de Propfirm",
        subtitle: "Découvrez notre sélection des meilleures propfirm pour financer votre trading",
        description: "Nous avons sélectionné les meilleures prop firms pour vous aider à obtenir un financement et développer votre carrière de trader.",
        benefits: "Avantages exclusifs",
        visitSite: "Visiter le site",
        learnMore: "En savoir plus",
        getStarted: "Commencer maintenant",
        exclusiveOffer: "Offres Exclusives Alturion",
        exclusiveOfferDescription: "En tant que client Alturion, bénéficiez d'avantages exclusifs et de conditions préférentielles auprès de nos partenaires prop firms. Contactez-nous pour en savoir plus !",
        discoverBenefits: "Découvrir les Avantages",
        contactUs: "Nous Contacter",
        verifiedPartners: "Partenaires vérifiés",
        negotiatedConditions: "Conditions négociées",
        dedicatedSupport: "Support dédié",
        quickComparison: "Comparaison Rapide",
        daysToPass: "Durée d'évaluation",
        accountTypes: "Types de comptes",
        drawdownType: "Type de drawdown",
        consistency: "Règle de cohérence",
        maxCapital: "Capital maximum",
        profitSplit: "Partage des profits",
        specifications: "Spécifications",
        popular: "Populaire",
        recommended: "Recommandé",
        noLimit: "Illimité",
        required: "Requise",
        notRequired: "Non requise",
        days: "jours",
        takeprofit: {
          name: "Takeprofit Trader",
          description: "Financement jusqu'à 150k€ avec des conditions avantageuses et un processus d'évaluation rapide",
          badge: "Accès Rapide",
          daysToPass: "5",
          accountTypes: "Challenge, Instant Funding",
          drawdown: "End of day",
          consistency: "Eval: 50% - Funded: Aucune",
          maxCapital: "150k€",
          profitSplit: "80-90%",
          url: "https://takeprofittrader.com",
          highlights: [
            "Processus d'évaluation rapide",
            "Conditions de trading flexibles",
            "Support client réactif"
          ]
        },
        lucidtrading: {
          name: "Lucid Trading",
          description: "Programme innovant avec capital jusqu'à 150k€ et partage des profits jusqu'à 90%",
          badge: "Formation Incluse",
          daysToPass: "2 (Flex)",
          accountTypes: "Challenge, Express",
          drawdown: "End of day",
          consistency: "Eval: 50% - Funded: 20%",
          maxCapital: "150k€",
          profitSplit: "80-90%",
          url: "https://lucidtrading.com",
          highlights: [
            "Formation trading incluse",
            "Durée flexible",
            "Règles de drawdown avantageuses"
          ]
        },
        apextradefunding: {
          name: "Apex Trade Funding",
          description: "Accès rapide au capital avec des comptes jusqu'à 300k€ et des règles de trading flexibles",
          badge: "Règles Flexibles",
          daysToPass: "1",
          accountTypes: "Challenge, Instant",
          drawdown: "End of day / Trailing",
          consistency: "Eval: Aucune - Funded: 30%",
          maxCapital: "300k€",
          profitSplit: "80-90%",
          url: "https://apextraderfunding.com",
          highlights: [
            "Règles de trading flexibles",
            "Support dédié 24/7",
            "Évaluation en 1 jour seulement"
          ]
        }
      },
      practicalGuides: {
        title: "Guides Pratiques",
        subtitle: "Tutoriels vidéo pour bien démarrer",
        comingSoonDescription: "Nous préparons des guides vidéo détaillés pour l'installation, l'activation de licence et la résolution de problèmes.",
        thirdPartyLicensing: {
          title: "Third Party Licensing — Étapes avant la demande de licence",
          description: "Suivez ces étapes importantes avant d'effectuer votre demande de licence NinjaTrader."
        },
        installation: {
          title: "Installation des Indicateurs",
          description: "Guide complet pour installer vos indicateurs NinjaTrader"
        },
        licensing: {
          title: "Activation de Licence",
          description: "Comment activer votre licence d'indicateur étape par étape"
        },
        troubleshooting: {
          title: "Résolution de Problèmes",
          description: "Solutions aux problèmes les plus courants"
        }
      },
      tradingEducation: {
        title: "Articles",
        subtitle: "Guides pour lire le marché, sans notice technique",
        readArticle: "Lire l'article",
        backToResources: "Retour aux ressources",
        notFound: "Cet article n'existe pas ou n'est plus disponible.",
        notFoundTitle: "Article introuvable",
        comingSoonDescription: "Nous préparons une sélection de vidéos techniques, livres recommandés et ressources éducatives pour améliorer vos compétences en trading.",
        technicalVideos: "Vidéos Techniques",
        recommendedBooks: "Livres Recommandés",
        videos: {
          advancedAnalysis: {
            title: "Analyse Technique Avancée",
            description: "Maîtrisez les concepts avancés de l'analyse technique"
          },
          riskManagement: {
            title: "Gestion du Risque en Trading",
            description: "Apprenez à gérer efficacement vos risques"
          }
        },
        books: {
          technicalAnalysis: {
            title: "Technical Analysis of the Financial Markets",
            author: "John J. Murphy",
            description: "Le guide de référence pour l'analyse technique"
          },
          marketWizards: {
            title: "Market Wizards",
            author: "Jack Schwager",
            description: "Interviews avec les meilleurs traders du monde"
          }
        }
      },
      toolsTemplates: {
        title: "Templates & Outils",
        subtitle: "Ressources gratuites pour optimiser votre trading",
        freeTemplates: "Templates Gratuits",
        tradingTools: "Outils de Trading",
        comingSoon: "Bientôt disponible",
        comingSoonDescription: "Nous préparons une sélection de templates et d'outils gratuits pour vous aider dans votre trading.",
        freeTemplatesDescription: "Templates de trading prêts à utiliser pour NinjaTrader",
        tradingToolsDescription: "Calculateurs et outils d'aide à la décision"
      },
      cta: {
        title: "Besoin d'aide personnalisée ?",
        description: "Notre équipe d'experts est là pour vous accompagner dans l'utilisation de nos indicateurs et vous aider à optimiser votre stratégie de trading.",
        button: "Contacter le Support"
      }
    },
    // Messages généraux
    common: {
      loading: "Chargement...",
      error: "Une erreur est survenue",
      success: "Succès",
      cancel: "Annuler",
      confirm: "Confirmer",
      save: "Enregistrer",
      edit: "Modifier",
      delete: "Supprimer",
      search: "Rechercher",
      filter: "Filtrer",
      reset: "Réinitialiser",
      lastUpdated: "Dernière mise à jour"
    },
    // Pages légales
    legal: {
      legalNotice: {
        title: "Mentions Légales",
        lastUpdated: "Dernière mise à jour",
        sections: {
          legalInfo: {
            title: "1. Informations légales",
            content: "Le site Alturion est édité par :",
            fields: {
              identity: "Nom",
              companyName: "Raison sociale",
              legalForm: "Forme juridique",
              tradeName: "Nom commercial",
              capital: "Capital social",
              siret: "Numéro SIRET",
              vat: "Numéro TVA Intracommunautaire",
              address: "Adresse",
              professionalAddress: "Adresse professionnelle",
              phone: "Téléphone",
              email: "Email"
            },
            values: {
              legalForm: "Entrepreneur individuel"
            }
          },
          publication: {
            title: "2. Direction de la publication",
            content: "Le directeur de la publication est Samy Bidar, entrepreneur individuel."
          },
          hosting: {
            title: "3. Hébergement",
            content: "Le site Alturion est hébergé et le nom de domaine est géré comme suit :",
            appHostLabel: "Hébergement de l'application (Railway) :",
            domainLabel: "Enregistrement du nom de domaine (Namecheap) :"
          },
          intellectualProperty: {
            title: "4. Propriété intellectuelle",
            content1: "L'ensemble du contenu du site Alturion (structure, textes, logos, images, vidéos, sons, etc.) est la propriété exclusive de Samy Bidar, exerçant sous le nom commercial Alturion Labs, ou de ses partenaires, et est protégé par les lois françaises et internationales relatives à la propriété intellectuelle.",
            content2: "Toute reproduction totale ou partielle de ce contenu est strictement interdite sans autorisation préalable."
          },
          personalData: {
            title: "5. Données personnelles",
            content1: "Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation du traitement, de portabilité des données et d'opposition au traitement de vos données personnelles.",
            content2: "Pour exercer ces droits ou pour toute question sur le traitement de vos données, vous pouvez nous contacter à l'adresse email : support@alturionlabs.com.",
            content3: "Pour plus d'informations sur la manière dont nous traitons vos données personnelles, veuillez consulter notre",
            privacyLink: "Politique de Confidentialité"
          },
          cookies: {
            title: "6. Cookies",
            content: "Le site Alturion utilise des cookies pour améliorer l'expérience utilisateur. Pour plus d'informations sur l'utilisation des cookies, veuillez consulter notre",
            cookieLink: "Politique de Cookies"
          },
          liability: {
            title: "7. Limitation de responsabilité",
            content1: "Samy Bidar s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur son site, dont il se réserve le droit de corriger le contenu à tout moment et sans préavis. Toutefois, Samy Bidar ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition sur ce site.",
            content2: "En conséquence, Samy Bidar décline toute responsabilité :",
            list: [
              "Pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur le site ;",
              "Pour tous dommages résultant d'une intrusion frauduleuse d'un tiers ayant entraîné une modification des informations mises à disposition sur le site ;",
              "Et plus généralement, pour tous dommages, directs ou indirects, quelles qu'en soient les causes, origines, natures ou conséquences, provoqués en raison de l'accès de quiconque au site ou de l'impossibilité d'y accéder."
            ]
          },
          law: {
            title: "8. Droit applicable et juridiction compétente",
            content: "Les présentes mentions légales sont soumises au droit français. En cas de litige, les tribunaux français seront seuls compétents."
          },
          contact: {
            title: "9. Contact",
            content: "Pour toute question relative aux présentes mentions légales, vous pouvez nous contacter à l'adresse suivante :"
          }
        }
      },
      cookiePolicy: {
        title: "Politique de Cookies",
        lastUpdated: "Dernière mise à jour",
        sections: {
          introduction: {
            title: "1. Introduction",
            content1: "Cette politique de cookies explique ce que sont les cookies, comment Alturion les utilise, et quels sont vos choix concernant leur utilisation.",
            content2: "Nous vous recommandons de lire cette politique pour comprendre les types de cookies que nous utilisons, les informations que nous collectons et comment ces informations sont utilisées."
          },
          whatAreCookies: {
            title: "2. Qu'est-ce qu'un cookie ?",
            content: "Les cookies sont de petits fichiers texte qui sont stockés sur votre ordinateur ou appareil mobile lorsque vous visitez un site web. Ils permettent au site de mémoriser vos actions et préférences (comme la connexion, la langue, la taille de police et d'autres préférences d'affichage) pendant un certain temps, afin que vous n'ayez pas à les saisir à chaque fois que vous revenez sur le site ou naviguez d'une page à l'autre."
          },
          howWeUseCookies: {
            title: "3. Comment utilisons-nous les cookies ?",
            content: "Notre site web utilise différents types de cookies pour diverses raisons :",
            types: {
              essential: {
                title: "Cookies essentiels",
                description: "Ces cookies sont nécessaires au bon fonctionnement de notre site. Ils vous permettent de naviguer sur notre site et d'utiliser ses fonctionnalités, comme l'accès aux zones sécurisées. Sans ces cookies, les services que vous avez demandés ne peuvent pas être fournis."
              },
              performance: {
                title: "Cookies de performance",
                description: "Ces cookies recueillent des informations sur la façon dont les visiteurs utilisent notre site, comme les pages les plus visitées ou si des messages d'erreur s'affichent sur certaines pages. Ces cookies ne recueillent pas d'informations permettant d'identifier un visiteur. Toutes les informations recueillies par ces cookies sont agrégées et donc anonymes. Elles servent uniquement à améliorer le fonctionnement de notre site."
              },
              functionality: {
                title: "Cookies de fonctionnalité",
                description: "Ces cookies permettent à notre site de se souvenir des choix que vous faites (comme votre nom d'utilisateur, votre langue ou la région où vous vous trouvez) et de proposer des fonctionnalités améliorées et plus personnalisées."
              },
              targeting: {
                title: "Cookies de ciblage ou publicitaires",
                description: "Ces cookies sont utilisés pour diffuser des publicités plus pertinentes pour vous et vos intérêts. Ils sont également utilisés pour limiter le nombre de fois où vous voyez une publicité, ainsi que pour aider à mesurer l'efficacité des campagnes publicitaires."
              }
            }
          },
          thirdPartyCookies: {
            title: "4. Cookies tiers",
            content: "En plus de nos propres cookies, nous pouvons également utiliser différents cookies tiers pour signaler les statistiques d'utilisation du site, diffuser des publicités, etc. Ces cookies peuvent inclure :",
            services: {
              googleAnalytics: "Google Analytics : Permet de suivre les statistiques de trafic du site.",
              stripe: "Stripe : Pour faciliter les paiements sécurisés sur notre site."
            }
          },
          manageCookies: {
            title: "5. Comment gérer les cookies",
            content1: "Vous pouvez contrôler et/ou supprimer les cookies comme vous le souhaitez. Vous pouvez supprimer tous les cookies déjà présents sur votre ordinateur et vous pouvez configurer la plupart des navigateurs pour les empêcher d'être placés. Toutefois, si vous faites cela, vous devrez peut-être ajuster manuellement certaines préférences chaque fois que vous visiterez un site, et certains services et fonctionnalités pourraient ne pas fonctionner.",
            content2: "Pour modifier vos paramètres de cookies dans votre navigateur :"
          },
          updates: {
            title: "6. Modifications de notre politique de cookies",
            content: "Nous pouvons mettre à jour cette politique de cookies de temps en temps pour refléter, par exemple, des changements dans les cookies que nous utilisons ou pour d'autres raisons opérationnelles, légales ou réglementaires. Nous vous encourageons à revisiter régulièrement cette politique pour rester informé de notre utilisation des cookies et des technologies connexes."
          },
          contact: {
            title: "7. Contactez-nous",
            content: "Si vous avez des questions concernant notre utilisation des cookies, veuillez nous contacter à :",
            email: "Email : support@alturionlabs.com"
          }
        }
      },
      privacyPolicy: {
        title: "Politique de Confidentialité",
        lastUpdated: "Dernière mise à jour",
        sections: {
          introduction: {
            title: "1. Introduction",
            content1: "Chez Alturion, nous accordons une grande importance à la protection de vos données personnelles et au respect de votre vie privée.",
            content2: "Cette politique de confidentialité vous informe sur la manière dont nous collectons, utilisons, stockons et protégeons vos informations personnelles lorsque vous utilisez notre site web et nos services."
          },
          dataCollection: {
            title: "2. Données que nous collectons",
            content1: "Nous collectons les informations suivantes :",
            list: [
              "Informations d'identification : nom, prénom, adresse email",
              "Informations de facturation : adresse, code postal, ville, pays",
              "Données de navigation : adresse IP, type de navigateur, pages visitées",
              "Informations de commande : produits achetés, historique des transactions"
            ]
          },
          dataUse: {
            title: "3. Utilisation de vos données",
            content1: "Nous utilisons vos données personnelles pour :",
            list: [
              "Traiter vos commandes et livrer nos produits",
              "Gérer votre compte client",
              "Vous contacter concernant vos commandes",
              "Améliorer nos services et votre expérience utilisateur",
              "Respecter nos obligations légales"
            ]
          },
          dataSharing: {
            title: "4. Partage de vos données",
            content1: "Nous ne vendons jamais vos données personnelles à des tiers.",
            content2: "Nous pouvons partager vos informations uniquement avec :",
            list: [
              "Nos prestataires de services (paiement, hébergement)",
              "Les autorités compétentes si requis par la loi",
              "Nos partenaires techniques pour la livraison de nos services"
            ]
          },
          dataRetention: {
            title: "5. Conservation des données",
            content1: "Nous conservons vos données personnelles pendant la durée nécessaire aux finalités pour lesquelles elles ont été collectées.",
            content2: "En général, nous conservons vos données :",
            list: [
              "Données de compte : tant que votre compte est actif",
              "Données de commande : 5 ans pour les obligations comptables",
              "Données de navigation : 13 mois maximum"
            ]
          },
          rights: {
            title: "6. Vos droits",
            content1: "Conformément au RGPD, vous disposez des droits suivants :",
            list: [
              "Droit d'accès à vos données personnelles",
              "Droit de rectification des données inexactes",
              "Droit d'effacement (droit à l'oubli)",
              "Droit à la portabilité de vos données",
              "Droit d'opposition au traitement",
              "Droit à la limitation du traitement"
            ],
            content2: "Pour exercer ces droits, contactez-nous à : support@alturionlabs.com"
          },
          security: {
            title: "7. Sécurité",
            content1: "Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données contre :",
            list: [
              "L'accès non autorisé",
              "La divulgation accidentelle",
              "La modification ou la destruction",
              "La perte de données"
            ]
          },
          cookies: {
            title: "8. Cookies",
            content1: "Notre site utilise des cookies pour améliorer votre expérience.",
            content2: "Pour plus d'informations, consultez notre politique de cookies."
          },
          contact: {
            title: "9. Contact",
            content1: "Pour toute question concernant cette politique de confidentialité :",
            email: "Email : support@alturionlabs.com"
          }
        }
      },
      terms: {
        title: "Conditions Générales de Vente",
        lastUpdated: "Dernière mise à jour",
        sections: {
          presentation: {
            title: "1. Présentation",
            content: "Les présentes Conditions Générales de Vente (ci-après \"CGV\") sont conclues entre :",
            parties: [
              "Samy Bidar, entrepreneur individuel, immatriculé sous le numéro SIRET 815 220 702 00030, dont l'adresse professionnelle est située 39 Bd Maurice Pourchon, 63100 Clermont-Ferrand, exerçant sous le nom commercial Alturion Labs, ci-après dénommé \"le Vendeur\" ;",
              "Et toute personne physique ou morale souhaitant procéder à un achat via le site Internet www.alturionlabs.com, ci-après dénommée \"l'Acheteur\"."
            ]
          },
          object: {
            title: "2. Objet",
            content: "Les présentes CGV régissent l'ensemble des relations contractuelles entre le Vendeur et l'Acheteur concernant la vente d'indicateurs de trading pour le logiciel NinjaTrader 8. Elles s'appliquent à l'exclusion de toutes autres conditions."
          },
          products: {
            title: "3. Produits",
            content: "Les produits proposés à la vente sont des indicateurs de trading destinés à être utilisés avec le logiciel NinjaTrader 8. Les caractéristiques essentielles des produits et leurs prix sont indiqués sur les pages de présentation correspondantes du site internet."
          },
          prices: {
            title: "4. Prix",
            content: "Les prix des produits sont indiqués en euros. Le Vendeur bénéficie de la franchise en base de TVA prévue à l'article 293 B du Code général des impôts : TVA non applicable. Le Vendeur se réserve le droit de modifier ses prix à tout moment, mais les produits seront facturés sur la base des tarifs en vigueur au moment de la validation de la commande."
          },
          order: {
            title: "5. Commande",
            content: "L'Acheteur qui souhaite acheter un produit doit :",
            steps: [
              "Créer un compte client ou s'identifier s'il possède déjà un compte;",
              "Remplir le formulaire de commande en donnant toutes les informations demandées;",
              "Valider sa commande après l'avoir vérifiée;",
              "Effectuer le paiement dans les conditions prévues;",
              "Confirmer sa commande et son règlement."
            ],
            confirmation: "La confirmation de la commande entraîne acceptation des présentes CGV et forme le contrat."
          },
          payment: {
            title: "6. Paiement",
            content: "Le paiement s'effectue en ligne par carte bancaire via la plateforme sécurisée Stripe. Le débit de la carte est effectué au moment de la validation de la commande."
          },
          delivery: {
            title: "7. Livraison",
            content: "S'agissant de produits numériques, la livraison s'effectue par transmission électronique (téléchargement) ou par l'envoi d'un email contenant les instructions d'accès au produit. La livraison est considérée comme effectuée dès la mise à disposition du produit à l'Acheteur."
          },
          withdrawal: {
            title: "8. Droit de rétractation",
            content1: "Conformément aux dispositions légales en vigueur, l'Acheteur dispose d'un délai de quatorze (14) jours à compter de la conclusion du contrat pour exercer son droit de rétractation, sans avoir à justifier de motifs ni à payer de pénalités.",
            content2: "Cependant, conformément à l'article L.221-28 du Code de la consommation, le droit de rétractation ne peut être exercé pour les contrats de fourniture d'un contenu numérique non fourni sur un support matériel dont l'exécution a commencé après accord préalable exprès du consommateur et renoncement exprès à son droit de rétractation.",
            content3: "En conséquence, en validant sa commande, l'Acheteur reconnaît expressément renoncer à son droit de rétractation dès la mise à disposition du contenu numérique."
          },
          warranties: {
            title: "9. Garanties",
            content: "Le Vendeur est tenu des défauts de conformité du bien au contrat dans les conditions de l'article L.217-4 et suivants du Code de la consommation et des défauts cachés de la chose vendue dans les conditions prévues aux articles 1641 et suivants du Code civil."
          },
          intellectualProperty: {
            title: "10. Propriété intellectuelle",
            content1: "Tous les éléments du site et les produits vendus sont et restent la propriété intellectuelle et exclusive du Vendeur. Personne n'est autorisé à reproduire, exploiter, ou utiliser à quelque titre que ce soit, même partiellement, ces éléments sans l'autorisation préalable et écrite du Vendeur.",
            content2: "L'achat d'un produit confère à l'Acheteur un droit d'utilisation personnel et non exclusif, non cessible et non transférable du produit concerné."
          },
          personalData: {
            title: "11. Données personnelles",
            content1: "Les données personnelles recueillies auprès des Acheteurs font l'objet d'un traitement informatique réalisé par le Vendeur. Elles sont enregistrées dans son fichier clients et sont indispensables au traitement de sa commande. Ces informations peuvent être communiquées aux partenaires du Vendeur chargés de l'exécution, du traitement, de la gestion et du paiement des commandes.",
            content2: "Le traitement des informations communiquées par l'intermédiaire du site internet respecte le Règlement Général sur la Protection des Données (RGPD). Pour plus d'informations, veuillez consulter notre",
            privacyLink: "Politique de Confidentialité"
          },
          forceMajeure: {
            title: "12. Force majeure",
            content: "L'exécution des obligations du Vendeur est suspendue en cas de survenance d'un cas fortuit ou de force majeure qui en empêcherait l'exécution. Le Vendeur avisera l'Acheteur de la survenance d'un tel évènement dès que possible."
          },
          law: {
            title: "13. Droit applicable et juridiction compétente",
            content1: "Les présentes CGV sont soumises au droit français. En cas de litige, les tribunaux français seront seuls compétents.",
            content2: "Toutefois, préalablement à tout recours au juge arbitral ou étatique, l'Acheteur est invité à contacter le service clientèle du Vendeur pour rechercher une solution amiable."
          },
          customerService: {
            title: "14. Service client",
            content: "Pour toute information, question ou réclamation, le client peut s'adresser au service client d'Alturion Labs :",
            email: "Par e-mail : support@alturionlabs.com",
            phone: "Par téléphone : 06 98 50 37 79",
            address: "Adresse : 39 Bd Maurice Pourchon, 63100 Clermont-Ferrand"
          }
        }
      },
      // Support page
      support: {
        hero: {
          title: "Support",
          description: "Notre équipe est là pour vous aider. Contactez-nous pour toute question concernant nos indicateurs ou votre compte."
        },
        contact: {
          title: "Contactez nous",
          description: "Remplissez le formulaire ci-dessous et nous vous répondrons dans les plus brefs délais.",
          labels: {
            name: "Nom complet",
            email: "Adresse e-mail",
            subject: "Sujet",
            message: "Message"
          },
          placeholders: {
            name: "Votre nom complet",
            email: "votre.email@exemple.com",
            subject: "Objet de votre demande",
            message: "Décrivez votre question ou problème en détail..."
          },
          sendButton: "Envoyer le message",
          loading: "Envoi en cours...",
          validation: {
            required: "Tous les champs sont requis",
            error: "Erreur lors de l'envoi du message. Veuillez réessayer plus tard."
          }
        },
        faq: {
          title: "Questions Fréquentes",
          description: "Trouvez rapidement des réponses aux questions les plus courantes.",
          items: [
            {
              question: "Comment installer mes indicateurs NinjaTrader ?",
              answer: "Après votre achat, téléchargez le fichier ZIP depuis votre profil. Ouvrez NinjaTrader 8, allez dans Tools > Import > NinjaScript Add-On, sélectionnez le fichier ZIP et redémarrez NinjaTrader."
            },
            {
              question: "Comment obtenir ma licence d'activation ?",
              answer: "Rendez-vous dans votre profil, section 'Mes Indicateurs', et cliquez sur 'Obtenir ma licence' pour l'indicateur concerné. Vous devrez fournir votre Machine ID signé NinjaTrader."
            },
            {
              question: "Que faire si mon indicateur ne fonctionne pas ?",
              answer: "Vérifiez d'abord que vous avez bien redémarré NinjaTrader après l'installation. Assurez-vous également d'avoir la bonne version de NinjaTrader (8.0 ou supérieur). Si le problème persiste, contactez notre support."
            },
            {
              question: "Puis-je utiliser mes indicateurs sur plusieurs ordinateurs ?",
              answer: "Chaque licence est liée à un Machine ID spécifique. Pour utiliser vos indicateurs sur un autre ordinateur, vous devrez demander une nouvelle licence avec le Machine ID de ce nouvel ordinateur."
            },
            {
              question: "Comment télécharger à nouveau mes indicateurs ?",
              answer: "Vous pouvez télécharger vos indicateurs à tout moment depuis votre profil, dans la section 'Mes Indicateurs'. Les liens de téléchargement restent actifs indéfiniment."
            }
          ]
        }
      }
    }
  }
};

// Traductions anglaises
const en = {
  translation: {
    // Navigation
    nav: {
      home: "Home",
      indicators: "Indicators",
      free: "Free",
      resources: "Resources",
      ninjatrader: "NinjaTrader",
      cart: "Cart",
      login: "Login",
      register: "Register",
      profile: "Profile",
      logout: "Logout"
    },
    // Home page
    home: {
      hero: {
        title: "Professional Trading Indicators",
        subtitle: "Developed by traders, for traders",
        description: "NinjaTrader 8 indicators for volume analysis, VWAP, and session levels — with guided installation and support included.",
        cta: "Explore our Products",
        demo: "Watch Demo"
      },
      features: {
        title: "Why choose Alturion?",
        precision: {
          title: "High Precision",
          description: "Our indicators are developed with meticulous attention to detail to ensure reliable signals."
        },
        quality: {
          title: "Premium Quality",
          description: "Each indicator is rigorously tested before being released to market."
        },
        support: {
          title: "Dedicated Support",
          description: "Our team of experts is here to support you in using our tools."
        }
      },
      products: {
        title: "Our Popular Indicators",
        viewAll: "View all indicators", 
        addToCart: "Add to cart",
        free: "FREE",
        reviews: "reviews",
        viewProduct: "View Product"
      },
      comingSoon: {
        index: "Roadmap",
        title: "Coming soon",
        subtitle: "Tools in the pipeline to expand your NinjaTrader toolkit.",
        badge: "Coming soon",
        ctaTitle: "Get notified at launch",
        ctaSubtitle: "One email is enough. We'll only write about these releases.",
        placeholder: "Your email address",
        submit: "Notify me",
        loading: "Sending...",
        success: "Thanks! We'll notify you when these indicators are available.",
        error: "Subscription error.",
        validation: {
          required: "Email required",
          error: "Invalid email format"
        },
        items: {
          footprint: {
            name: "Footprint",
            teaser: "Tick-by-tick reading of buy and sell aggression at each price level."
          },
          "cumulative-delta": {
            name: "Cumulative Delta",
            teaser: "Cumulative buy/sell flow to visualize imbalance over time."
          },
          "delta-profile": {
            name: "Delta Profile",
            teaser: "Delta distribution by price to see where flow truly contested."
          },
          "big-trades": {
            name: "Big Trades",
            teaser: "Large prints highlighted so you can see where size actually traded."
          },
          dashboard: {
            name: "Dashboard",
            teaser: "A multi-tool overview to track your Alturion indicators at a glance."
          }
        }
      },
      tradingStyles: {
        title: "Choose Your Trading Style",
        subtitle: "Sophisticated tools for every trading approach",
        volumeAnalysis: {
          title: "Volume Analysis",
          description: "Use the power of volume analysis to identify true zones of interest."
        },
        sessionLevels: {
          title: "Session Levels",
          description: "Leverage key levels from different trading sessions to anticipate movements."
        },
        intradayTrading: {
          title: "Intraday Trading", 
          description: "Get precise and responsive signals for your intraday and scalping operations."
        }
      },
      cta: {
        title: "Ready to Transform Your Trading?",
        subtitle: "Try our indicators for 7 days. Guided installation, updates, and support included.",
        button: "Discover Our Indicators"
      },
      guaranteePopup: {
        title: "🎯 Special Offer",
        subtitle: "Try our indicators risk-free",
        guarantee: "7-day money-back guarantee",
        description: "Test our premium indicators for a full 7 days. If you're not completely satisfied, we'll refund you in full.",
        benefits: [
          "✅ Full refund within 7 days",
          "✅ Technical support included",
          "✅ Guided installation",
          "✅ Free updates"
        ],
        cta: "Discover our Indicators",
        close: "Close",
        limitedTime: "Limited time offer"
      },
      testimonials: {
        title: "What Our Clients Say",
        items: [
          {
            quote: "Alturion's indicators have completely transformed my trading approach. The Volume Profile allowed me to identify key zones with incredible precision.",
            author: "Thomas L.",
            role: "Day Trader"
          },
          {
            quote: "The VWAP Premium indicator has become an indispensable tool in my arsenal. The deviation bands are perfect for spotting scalping opportunities.",
            author: "Sophie M.",
            role: "Institutional Trader"
          },
          {
            quote: "Asian Session Levels gave me a significant advantage in preparing my European session trades. Impeccable customer service!",
            author: "Marc D.",
            role: "Swing Trader"
          }
        ]
      },
      contact: {
        title: "Contact us",
        description: "Have a question? Need help? Our team is here for you.",
        name: "Name",
        email: "Email",
        subject: "Subject",
        message: "Message",
        send: "Send message",
        sendButton: "Send",
        success: "Message sent successfully!",
        error: "Error sending message.",
        placeholders: {
          name: "Your name",
          email: "Your email",
          subject: "Subject",
          message: "Your message"
        },
        validation: {
          required: "All fields are required",
          error: "Error sending message. Please try again later."
        },
        loading: "Sending..."
      },
      newsletter: {
        title: "Stay informed about our innovations",
        description: "Subscribe to our newsletter to receive our latest news and trading tips.",
        placeholder: "Your email address",
        subscribe: "Subscribe",
        success: "Successfully subscribed!",
        error: "Subscription error.",
        loading: "Subscribing...",
        validation: {
          required: "Email required",
          error: "Invalid email format"
        }
      }
    },
    // Indicators page
    indicators: {
      title: "Our Indicators",
      subtitle: "Discover our complete range of technical indicators",
      categories: {
        all: "All",
        volume: "Volume",
        levels: "Levels",
        analysis: "Analysis"
      },
      sortBy: "Sort by",
      sort: {
        name: "Name",
        price: "Price",
        rating: "Rating"
      },
      noProducts: "No products found.",
      addToCart: "Add to cart",
      free: "FREE"
    },
    // Product page
    product: {
      addToCart: "Add to cart",
      backToProducts: "Back to indicators",
      price: "Price",
      free: "FREE",
      category: "Category",
      compatibility: "Compatibility",
      rating: "Rating",
      reviews: "reviews",
      features: "Features",
      description: "Detailed description",
      images: "Images",
      outOfStock: "Out of stock",
      quantity: "Quantity",
      selectQuantity: "Select quantity"
    },
    cookieBanner: {
      title: "We respect your privacy",
      body: "This site uses cookies to improve your experience and our services. By continuing, you accept cookies as described in our",
      policy: "cookie policy",
      decline: "Decline",
      customize: "Customize",
      accept: "Accept"
    },
    // Cart
    cart: {
      title: "Shopping Cart",
      empty: "Your cart is empty",
      backToShopping: "← Continue shopping",
      item: "Item",
      quantity: "Quantity",
      price: "Price",
      total: "Total",
      subtotal: "Subtotal",
      checkout: "Proceed to checkout",
      remove: "Remove",
      summary: "Order Summary",
      items: "Items"
    },
    // Checkout
    checkout: {
      orderSummary: "Order Summary",
      quantity: "Quantity",
      total: "Total",
      free: "FREE",
      freeProducts: "Free products - No payment required",
      confirmFreeOrder: "Confirm free order",
      pay: "Pay {{price}}",
      securePayment: "Secure payment",
      processing: {
        title: "Processing...",
        verifying: "Verifying information...",
        validating: "Validating order...",
        processing: "Processing payment...",
        finalizing: "Finalizing...",
        completed: "completed"
      }
    },
    // Checkout success page
    checkoutSuccess: {
      paymentAccepted: "Payment accepted!",
      thankYou: "Thank you for your order",
      orderProcessed: "Your order has been processed successfully.",
      orderNumber: "Order number",
      indicatorsAvailable: "Your indicators are now available in your client area.",
      emailSent: "A confirmation has been sent to your email.",
      findOrder: {
        title: "Find your order",
        description: "in the \"My Orders\" tab of your profile."
      },
      redirecting: "Redirecting to your orders in {{seconds}} seconds...",
      stayOnPage: "Stay on this page",
      viewOrders: "View my orders",
      verifying: "Verifying your payment...",
      backToCart: "Back to cart",
      errors: {
        invalidId: "Invalid session or order ID.",
        unauthorized: "Unauthorized access.",
        timeout: "Payment verification timeout. Please check your profile for order status.",
        orderVerification: "An error occurred while verifying the order.",
        paymentVerification: "Unable to verify payment status.",
        general: "An error occurred while verifying payment."
      }
    },
    // Authentication
    auth: {
      login: {
        title: "Sign In",
        email: "Email address",
        password: "Password",
        submit: "Sign In",
        noAccount: "New customer?",
        register: "Register"
      },
      register: {
        title: "Create Account",
        name: "Full name",
        email: "Email address",
        password: "Password",
        confirmPassword: "Confirm password",
        submit: "Register",
        hasAccount: "Already have an account?",
        login: "Sign In",
        passwordMismatch: "Passwords do not match"
      }
    },
    // NinjaTrader
    ninjatrader: {
      title: "Our Recommended Trading Platform",
      subtitle: "The professional trading platform",
      description: "NinjaTrader® is our #1 trading platform, preferred by traders worldwide, including our clients.",
      downloadTitle: "Download NinjaTrader",
      downloadSubtitle: "& get immediate FREE access to:",
      features: [
        "Simulated trading with real-time futures data",
        "Advanced charts with the ability to trade directly from your charts",
        "High-performance backtesting engine to analyze your strategies on historical data",
        "Advanced trade management with automatic stop, target and trailing stop orders"
      ],
      platformDescription: "NinjaTrader's award-winning trading platform is regularly voted industry leader by the trading community. With thousands of apps and add-ons for unlimited customization, NinjaTrader is used by over 1.9 million traders for advanced market analysis, professional charting and fast order execution.",
      kinetick: {
        title: "Our Recommended Market Data Service",
        description1: "Kinetick® provides reliable, fast and cost-effective market data to help level the playing field for active traders. Enjoy unfiltered real-time quotes for stocks, futures and forex that exceed the expectations of the most demanding traders, like us!",
        description2: "Start with FREE end-of-day historical data directly through the NinjaTrader platform and discover how you can significantly reduce CME Group Globex exchange fees on real-time data with Kinetick."
      },
      cta: {
        download: "START FOR FREE",
        data: "START WITH FREE EOD DATA"
      }
    },
    // Footer
    footer: {
      company: "Company",
      products: "Products",
      support: "Support",
      legal: "Legal",
      navigation: "Navigation",
      description: "We develop innovative trading indicators for NinjaTrader 8, designed to optimize your strategies and maximize your performance in financial markets.",
      links: {
        about: "About",
        contact: "Contact",
        indicators: "Indicators",
        ninjatrader: "NinjaTrader",
        help: "Help",
        faq: "FAQ",
        privacy: "Privacy Policy",
        terms: "Terms of Service",
        cookies: "Cookie Policy",
        refund: "Refund Policy",
        legalNotice: "Legal Notice"
      },
      copyright: "© 2024 Alturion. All rights reserved.",
      disclaimer: "Past performance does not guarantee future results. Trading involves risk of loss."
    },
    // User profile
    profile: {
      title: "My Profile",
      tabs: {
        profile: "My Profile",
        indicators: "My Indicators",
        orders: "My Orders"
      },
      account: {
        title: "Account Information",
        name: "Name",
        email: "Email",
        editButton: "Edit profile",
        editTitle: "Edit my profile"
      },
      billing: {
        title: "Billing Information",
        description: "This information will be used to generate your invoices.",
        name: "Name / Company",
        address: "Address",
        zipCode: "Zip Code",
        city: "City",
        country: "Country",
        vat: "VAT Number",
        notProvided: "Not provided",
        notProvidedFeminine: "Not provided",
        updateButton: "Update billing information"
      },
      messages: {
        thankYou: "Thank you for your purchase!",
        orderSuccess: "Your order has been processed successfully. You can now access your indicators.",
        profileUpdated: "Profile updated successfully!",
        close: "Close"
      },
      form: {
        name: "Name",
        email: "Email Address",
        currentPassword: "Current password",
        newPassword: "New password",
        confirmPassword: "Confirm password",
        changePassword: "Change password",
        passwordNote: "Leave these fields blank if you don't want to change your password",
        updating: "Updating...",
        update: "Update",
        cancel: "Cancel",
        placeholders: {
          name: "Enter your name",
          email: "Enter your email",
          currentPassword: "Enter your current password",
          newPassword: "Enter a new password",
          confirmPassword: "Confirm your new password"
        },
        errors: {
          passwordMismatch: "Passwords do not match",
          oldPasswordRequired: "Please enter your old password to change it",
          emailChanged: "Your email has been changed. Do you want to reconnect with the new information?"
        }
      },
      billingForm: {
        title: "Billing Information",
        success: "Your billing information has been updated successfully.",
        error: "An error occurred. Please try again.",
        fields: {
          name: "Name / Company",
          address: "Address",
          zipCode: "Zip Code",
          city: "City",
          country: "Country",
          vat: "VAT Number (optional)"
        },
        placeholders: {
          name: "Enter your name or company name",
          address: "Enter your address",
          zipCode: "Enter your zip code",
          city: "Enter your city",
          country: "Enter your country",
          vat: "Enter your VAT number if applicable"
        },
        updating: "Updating...",
        update: "Update",
        cancel: "Cancel",
        close: "Close"
      },
      indicators: {
        title: "My Indicators",
        installGuide: {
          title: "Quick Installation Guide",
          steps: [
            "Download the ZIP file after your purchase",
            "Open NinjaTrader 8",
            "Go to Tools > Import > NinjaScript Add-On...",
            "Select the downloaded ZIP file",
            "Restart NinjaTrader 8"
          ],
          requirements: "System requirements:",
          requirementsList: "NinjaTrader 8, Windows 10/11 64-bit, 4 GB RAM",
          support: "Need help?",
          contactSupport: "Contact our support"
        },
        licenseGuide: {
          title: "Quick License Activation Guide",
          steps: [
            "Open NinjaTrader Control Center",
            "Click on Help > \"3rd party licensing\"",
            "In \"Vendor Name\", enter: Alturion",
            "In \"User Defined ID\", enter your name or identifier",
            "Click \"Submit\" only once",
            "Copy the generated \"Signed Machine ID\"",
            "Click 'Get my license' for your indicator and paste your Signed Machine ID"
          ],
          requirements: "⚠️ Important:",
          requirementsList: "Unsigned Machine IDs are not accepted",
          support: "License issue?",
          contactSupport: "Contact our support"
        },
        purchased: {
          purchasedOn: "Purchased on",
          download: "Download",
          getLicense: "Get my license",
          tagLicenseRequired: "License required",
          tagNoLicense: "No activation",
          noActivationNeeded: "No activation required",
          noIndicators: "You don't have any indicators yet.",
          discoverIndicators: "Discover our indicators"
        },
        licenseModal: {
          title: "Activate your license",
          productInfo: "To activate your license, we need some information",
          instructions: {
            title: "How to generate your Signed NinjaTrader Machine ID?",
            steps: [
              "Open NinjaTrader Control Center",
              "Click on Help > \"3rd party licensing\"",
              "In \"Vendor Name\", enter: Alturion",
              "In \"User Defined ID\", enter your name or identifier",
              "Click \"Submit\" only once",
              "Copy the generated \"Signed Machine ID\""
            ],
            screenshotAlt: "NinjaTrader « 3rd Party Licensing » window: Vendor name Alturion, User defined ID, then Submit",
            warning: "Unsigned Machine IDs are not accepted"
          },
          form: {
            label: "Signed Machine ID-Name *",
            placeholder: "Ex: ABC123DEF456-JohnDoe",
            description: "The Signed Machine ID generated by NinjaTrader followed by your name",
            formatRequired: "Required format: MachineID-Name (dash is required)",
            cancel: "Cancel",
            submit: "Submit",
            sending: "Sending..."
          },
          validation: {
            required: "Machine ID-Name is required",
            missingDash: "Format must be \"MachineID-Name\". The dash (-) is required to separate the Machine ID from your name.",
            missingName: "Format must be \"MachineID-Name\". Please add your name or nickname after the dash.",
            emptyMachineId: "The Machine ID part (before the dash) cannot be empty.",
            emptyName: "The name part (after the dash) cannot be empty. Please add your name or nickname.",
            shortMachineId: "The Machine ID seems too short. Make sure to use the \"Signed Machine ID\" generated by NinjaTrader.",
            shortName: "The name must contain at least 2 characters.",
            duplicate: "This Machine ID-Name is already used for this product. Please choose a different one."
          },
          footer: "Your information is secure and used only for license activation."
        }
      },
      orders: {
        title: "My Orders",
        noOrders: "You don't have any orders yet",
        columns: {
          id: "ID",
          date: "Date",
          total: "Total",
          paid: "Paid",
          items: "Items",
          invoice: "Invoice"
        },
        paid: "Paid date",
        notPaid: "Not paid",
        generating: "Generating...",
        unknownDate: "Unknown date",
        invoiceSuccess: "Invoice downloaded successfully!"
      }
    },
    // Resources Page
    resources: {
      title: "Resources",
      subtitle: "Discover our trusted partners and access exclusive resources to optimize your trading",
      propFirms: {
        title: "Our Propfirm Selection",
        subtitle: "Discover our selection of the best propfirms to fund your trading",
        description: "We have selected the best prop firms to help you get funding and develop your trading career.",
        benefits: "Exclusive benefits",
        visitSite: "Visit site",
        learnMore: "Learn more",
        getStarted: "Get started now",
        exclusiveOffer: "Exclusive Alturion Offers",
        exclusiveOfferDescription: "As an Alturion client, benefit from exclusive advantages and preferential conditions with our prop firm partners. Contact us to learn more!",
        discoverBenefits: "Discover Benefits",
        contactUs: "Contact Us",
        verifiedPartners: "Verified partners",
        negotiatedConditions: "Negotiated conditions",
        dedicatedSupport: "Dedicated support",
        quickComparison: "Quick Comparison",
        daysToPass: "Evaluation period",
        accountTypes: "Account types",
        drawdownType: "Drawdown type",
        consistency: "Consistency rule",
        maxCapital: "Maximum capital",
        profitSplit: "Profit split",
        specifications: "Specifications",
        popular: "Popular",
        recommended: "Recommended",
        noLimit: "Unlimited",
        required: "Required",
        notRequired: "Not required",
        days: "days",
        takeprofit: {
          name: "Takeprofit Trader",
          description: "Funding up to $150k with advantageous conditions and fast evaluation process",
          badge: "Fast Access",
          daysToPass: "5",
          accountTypes: "Challenge, Instant Funding",
          drawdown: "End of day",
          consistency: "Eval: 50% - Funded: None",
          maxCapital: "$150k",
          profitSplit: "80-90%",
          url: "https://takeprofittrader.com",
          highlights: [
            "Fast evaluation process",
            "Flexible trading conditions",
            "Responsive customer support"
          ]
        },
        lucidtrading: {
          name: "Lucid Trading",
          description: "Innovative program with capital up to $150k and profit sharing up to 90%",
          badge: "Training Included",
          daysToPass: "2 (Flex)",
          accountTypes: "Challenge, Express",
          drawdown: "End of day",
          consistency: "Eval: 50% - Funded: 20%",
          maxCapital: "$150k",
          profitSplit: "80-90%",
          url: "https://lucidtrading.com",
          highlights: [
            "Trading training included",
            "Flexible duration",
            "Advantageous drawdown rules"
          ]
        },
        apextradefunding: {
          name: "Apex Trade Funding",
          description: "Fast access to capital with accounts up to $300k and flexible trading rules",
          badge: "Flexible Rules",
          daysToPass: "1",
          accountTypes: "Challenge, Instant",
          drawdown: "End of day / Trailing",
          consistency: "Eval: None - Funded: 30%",
          maxCapital: "$300k",
          profitSplit: "80-90%",
          url: "https://apextraderfunding.com",
          highlights: [
            "Flexible trading rules",
            "24/7 dedicated support",
            "1-day evaluation only"
          ]
        }
      },
      practicalGuides: {
        title: "Practical Guides",
        subtitle: "Video tutorials to get you started",
        comingSoonDescription: "We are preparing detailed video guides for installation, license activation and troubleshooting.",
        thirdPartyLicensing: {
          title: "Third Party Licensing — Steps Before License Request",
          description: "Follow these important steps before submitting your NinjaTrader license request."
        },
        installation: {
          title: "Indicator Installation",
          description: "Complete guide to install your NinjaTrader indicators"
        },
        licensing: {
          title: "License Activation",
          description: "How to activate your indicator license step by step"
        },
        troubleshooting: {
          title: "Troubleshooting",
          description: "Solutions to the most common problems"
        }
      },
      tradingEducation: {
        title: "Articles",
        subtitle: "Guides to read the market, not product manuals",
        readArticle: "Read the article",
        backToResources: "Back to resources",
        notFound: "This article does not exist or is no longer available.",
        notFoundTitle: "Article not found",
        comingSoonDescription: "We are preparing a selection of technical videos, recommended books and educational resources to improve your trading skills.",
        technicalVideos: "Technical Videos",
        recommendedBooks: "Recommended Books",
        videos: {
          advancedAnalysis: {
            title: "Advanced Technical Analysis",
            description: "Master advanced technical analysis concepts"
          },
          riskManagement: {
            title: "Risk Management in Trading",
            description: "Learn to effectively manage your risks"
          }
        },
        books: {
          technicalAnalysis: {
            title: "Technical Analysis of the Financial Markets",
            author: "John J. Murphy",
            description: "The reference guide for technical analysis"
          },
          marketWizards: {
            title: "Market Wizards",
            author: "Jack Schwager",
            description: "Interviews with the world's best traders"
          }
        }
      },
      toolsTemplates: {
        title: "Templates & Tools",
        subtitle: "Free resources to optimize your trading",
        freeTemplates: "Free Templates",
        tradingTools: "Trading Tools",
        comingSoon: "Coming Soon",
        comingSoonDescription: "We are preparing a selection of free templates and tools to help you with your trading.",
        freeTemplatesDescription: "Ready-to-use trading templates for NinjaTrader",
        tradingToolsDescription: "Calculators and decision-making tools"
      },
      cta: {
        title: "Need personalized help?",
        description: "Our team of experts is here to support you in using our indicators and help you optimize your trading strategy.",
        button: "Contact Support"
      }
    },
    // Common messages
    common: {
      loading: "Loading...",
      error: "An error occurred",
      success: "Success",
      cancel: "Cancel",
      confirm: "Confirm",
      save: "Save",
      edit: "Edit",
      delete: "Delete",
      search: "Search",
      filter: "Filter",
      reset: "Reset",
      lastUpdated: "Last updated"
    },
    // Legal pages
    legal: {
      legalNotice: {
        title: "Legal Notice",
        lastUpdated: "Last updated",
        sections: {
          legalInfo: {
            title: "1. Legal Information",
            content: "The Alturion website is published by:",
            fields: {
              identity: "Name",
              companyName: "Company name",
              legalForm: "Legal form",
              tradeName: "Trade name",
              capital: "Share capital",
              siret: "SIRET number",
              vat: "VAT number",
              address: "Address",
              professionalAddress: "Professional address",
              phone: "Phone",
              email: "Email"
            },
            values: {
              legalForm: "Sole trader (entrepreneur individuel)"
            }
          },
          publication: {
            title: "2. Publication management",
            content: "The publication director is Samy Bidar, sole trader (entrepreneur individuel)."
          },
          hosting: {
            title: "3. Hosting",
            content: "The Alturion website is hosted and the domain name is managed as follows:",
            appHostLabel: "Application hosting (Railway):",
            domainLabel: "Domain name registration (Namecheap):"
          },
          intellectualProperty: {
            title: "4. Intellectual property",
            content1: "All content on the Alturion website (structure, texts, logos, images, videos, sounds, etc.) is the exclusive property of Samy Bidar, trading as Alturion Labs, or of his partners, and is protected by French and international laws relating to intellectual property.",
            content2: "Any total or partial reproduction of this content is strictly prohibited without prior authorization."
          },
          personalData: {
            title: "5. Personal data",
            content1: "In accordance with the General Data Protection Regulation (GDPR) and the Data Protection Act, you have the right to access, rectify, erase, limit processing, data portability and object to the processing of your personal data.",
            content2: "To exercise these rights or for any questions about the processing of your data, you can contact us at the email address: support@alturionlabs.com.",
            content3: "For more information on how we process your personal data, please consult our",
            privacyLink: "Privacy Policy"
          },
          cookies: {
            title: "6. Cookies",
            content: "The Alturion website uses cookies to improve the user experience. For more information on the use of cookies, please consult our",
            cookieLink: "Cookie Policy"
          },
          liability: {
            title: "7. Limitation of liability",
            content1: "Samy Bidar strives to ensure the accuracy and updating of information published on the website, for which he reserves the right to correct the content at any time and without notice. However, Samy Bidar cannot guarantee the accuracy, precision or completeness of the information made available on this website.",
            content2: "Consequently, Samy Bidar disclaims all responsibility:",
            list: [
              "For any inaccuracy, inaccuracy or omission relating to information available on the site;",
              "For all damage resulting from fraudulent intrusion by a third party having resulted in modification of information made available on the site;",
              "And more generally, for all damage, direct or indirect, whatever their causes, origins, nature or consequences, caused due to anyone's access to the site or the impossibility of accessing it."
            ]
          },
          law: {
            title: "8. Applicable law and competent jurisdiction",
            content: "This legal notice is subject to French law. In case of dispute, French courts will have sole jurisdiction."
          },
          contact: {
            title: "9. Contact",
            content: "For any questions relating to this legal notice, you can contact us at the following address:"
          }
        }
      },
      cookiePolicy: {
        title: "Cookie Policy",
        lastUpdated: "Last updated",
        sections: {
          introduction: {
            title: "1. Introduction",
            content1: "This cookie policy explains what cookies are, how Alturion uses them, and what your choices are regarding their use.",
            content2: "We recommend reading this policy to understand the types of cookies we use, the information we collect and how this information is used."
          },
          whatAreCookies: {
            title: "2. What is a cookie?",
            content: "Cookies are small text files that are stored on your computer or mobile device when you visit a website. They allow the site to remember your actions and preferences (such as login, language, font size and other display preferences) for a certain period of time, so you don't have to enter them every time you return to the site or navigate from page to page."
          },
          howWeUseCookies: {
            title: "3. How do we use cookies?",
            content: "Our website uses different types of cookies for various reasons:",
            types: {
              essential: {
                title: "Essential cookies",
                description: "These cookies are necessary for the proper functioning of our site. They allow you to navigate our site and use its features, such as access to secure areas. Without these cookies, the services you have requested cannot be provided."
              },
              performance: {
                title: "Performance cookies",
                description: "These cookies collect information about how visitors use our site, such as the most visited pages or if error messages appear on certain pages. These cookies do not collect information that identifies a visitor. All information collected by these cookies is aggregated and therefore anonymous. They are only used to improve the functioning of our site."
              },
              functionality: {
                title: "Functionality cookies",
                description: "These cookies allow our site to remember the choices you make (such as your username, your language or the region where you are located) and to offer enhanced and more personalized features."
              },
              targeting: {
                title: "Targeting or advertising cookies",
                description: "These cookies are used to deliver advertisements more relevant to you and your interests. They are also used to limit the number of times you see an advertisement, as well as to help measure the effectiveness of advertising campaigns."
              }
            }
          },
          thirdPartyCookies: {
            title: "4. Third-party cookies",
            content: "In addition to our own cookies, we may also use various third-party cookies to report website usage statistics, deliver advertisements, etc. These cookies may include:",
            services: {
              googleAnalytics: "Google Analytics: Allows tracking of site traffic statistics.",
              stripe: "Stripe: To facilitate secure payments on our site."
            }
          },
          manageCookies: {
            title: "5. How to manage cookies",
            content1: "You can control and/or delete cookies as you wish. You can delete all cookies already present on your computer and you can configure most browsers to prevent them from being placed. However, if you do this, you may need to manually adjust some preferences each time you visit a site, and some services and features may not work.",
            content2: "To modify your cookie settings in your browser:"
          },
          updates: {
            title: "6. Changes to our cookie policy",
            content: "We may update this cookie policy from time to time to reflect, for example, changes in the cookies we use or for other operational, legal or regulatory reasons. We encourage you to regularly revisit this policy to stay informed about our use of cookies and related technologies."
          },
          contact: {
            title: "7. Contact us",
            content: "If you have any questions regarding our use of cookies, please contact us at:",
            email: "Email: support@alturionlabs.com"
          }
        }
      },
      privacyPolicy: {
        title: "Privacy Policy",
        lastUpdated: "Last updated",
        sections: {
          introduction: {
            title: "1. Introduction",
            content1: "At Alturion, we place great importance on protecting your personal data and respecting your privacy.",
            content2: "This privacy policy informs you about how we collect, use, store and protect your personal information when you use our website and services."
          },
          dataCollection: {
            title: "2. Data we collect",
            content1: "We collect the following information:",
            list: [
              "Identification information: name, first name, email address",
              "Billing information: address, postal code, city, country",
              "Navigation data: IP address, browser type, pages visited",
              "Order information: products purchased, transaction history"
            ]
          },
          dataUse: {
            title: "3. Use of your data",
            content1: "We use your personal data to:",
            list: [
              "Process your orders and deliver our products",
              "Manage your customer account",
              "Contact you regarding your orders",
              "Improve our services and your user experience",
              "Comply with our legal obligations"
            ]
          },
          dataSharing: {
            title: "4. Sharing your data",
            content1: "We never sell your personal data to third parties.",
            content2: "We may share your information only with:",
            list: [
              "Our service providers (payment, hosting)",
              "Competent authorities if required by law",
              "Our technical partners for service delivery"
            ]
          },
          dataRetention: {
            title: "5. Data retention",
            content1: "We retain your personal data for the time necessary for the purposes for which it was collected.",
            content2: "Generally, we retain your data:",
            list: [
              "Account data: as long as your account is active",
              "Order data: 5 years for accounting obligations",
              "Navigation data: maximum 13 months"
            ]
          },
          rights: {
            title: "6. Your rights",
            content1: "In accordance with GDPR, you have the following rights:",
            list: [
              "Right of access to your personal data",
              "Right to rectify inaccurate data",
              "Right to erasure (right to be forgotten)",
              "Right to data portability",
              "Right to object to processing",
              "Right to restrict processing"
            ],
            content2: "To exercise these rights, contact us at: support@alturionlabs.com"
          },
          security: {
            title: "7. Security",
            content1: "We implement appropriate technical and organizational measures to protect your data against:",
            list: [
              "Unauthorized access",
              "Accidental disclosure",
              "Modification or destruction",
              "Data loss"
            ]
          },
          cookies: {
            title: "8. Cookies",
            content1: "Our site uses cookies to improve your experience.",
            content2: "For more information, see our cookie policy."
          },
          contact: {
            title: "9. Contact",
            content1: "For any questions regarding this privacy policy:",
            email: "Email: support@alturionlabs.com"
          }
        }
      },
      terms: {
        title: "Terms of Service",
        lastUpdated: "Last updated",
        sections: {
          presentation: {
            title: "1. Presentation",
            content: "These Terms of Service (hereinafter \"Terms\") are concluded between:",
            parties: [
              "Samy Bidar, sole trader (entrepreneur individuel), registered under SIRET number 815 220 702 00030, whose professional address is located at 39 Bd Maurice Pourchon, 63100 Clermont-Ferrand, trading under the name Alturion Labs, hereinafter referred to as \"the Seller\";",
              "And any natural or legal person wishing to make a purchase via the website www.alturionlabs.com, hereinafter referred to as \"the Buyer\"."
            ]
          },
          object: {
            title: "2. Object",
            content: "These Terms govern all contractual relationships between the Seller and the Buyer concerning the sale of trading indicators for NinjaTrader 8 software. They apply to the exclusion of all other conditions."
          },
          products: {
            title: "3. Products",
            content: "The products offered for sale are trading indicators intended to be used with NinjaTrader 8 software. The essential characteristics of the products and their prices are indicated on the corresponding presentation pages of the website."
          },
          prices: {
            title: "4. Prices",
            content: "Product prices are indicated in euros. The Seller benefits from the VAT franchise provided for in article 293 B of the French General Tax Code: VAT not applicable. The Seller reserves the right to modify its prices at any time, but products will be invoiced based on the rates in effect at the time of order validation."
          },
          order: {
            title: "5. Order",
            content: "The Buyer who wishes to purchase a product must:",
            steps: [
              "Create a customer account or identify themselves if they already have an account;",
              "Fill out the order form by providing all requested information;",
              "Validate their order after checking it;",
              "Make payment under the conditions provided;",
              "Confirm their order and payment."
            ],
            confirmation: "Order confirmation entails acceptance of these Terms and forms the contract."
          },
          payment: {
            title: "6. Payment",
            content: "Payment is made online by credit card via the secure Stripe platform. The card is debited at the time of order validation."
          },
          delivery: {
            title: "7. Delivery",
            content: "As these are digital products, delivery is carried out by electronic transmission (download) or by sending an email containing product access instructions. Delivery is considered completed as soon as the product is made available to the Buyer."
          },
          withdrawal: {
            title: "8. Right of withdrawal",
            content1: "In accordance with the legal provisions in force, the Buyer has a period of fourteen (14) days from the conclusion of the contract to exercise their right of withdrawal, without having to justify reasons or pay penalties.",
            content2: "However, in accordance with article L.221-28 of the Consumer Code, the right of withdrawal cannot be exercised for contracts for the supply of digital content not provided on a material medium whose execution has begun after the express prior agreement of the consumer and express waiver of their right of withdrawal.",
            content3: "Consequently, by validating their order, the Buyer expressly acknowledges waiving their right of withdrawal as soon as the digital content is made available."
          },
          warranties: {
            title: "9. Warranties",
            content: "The Seller is bound by defects in conformity of the good to the contract under the conditions of article L.217-4 and following of the Consumer Code and hidden defects of the thing sold under the conditions provided for in articles 1641 and following of the Civil Code."
          },
          intellectualProperty: {
            title: "10. Intellectual property",
            content1: "All elements of the site and the products sold are and remain the intellectual and exclusive property of the Seller. No one is authorized to reproduce, exploit, or use in any capacity whatsoever, even partially, these elements without the prior written authorization of the Seller.",
            content2: "The purchase of a product grants the Buyer a personal and non-exclusive, non-transferable and non-transferable right to use the product concerned."
          },
          personalData: {
            title: "11. Personal data",
            content1: "Personal data collected from Buyers is subject to computer processing carried out by the Seller. They are recorded in their customer file and are essential for processing their order. This information may be communicated to the Seller's partners responsible for execution, processing, management and payment of orders.",
            content2: "The processing of information communicated through the website complies with the General Data Protection Regulation (GDPR). For more information, please consult our",
            privacyLink: "Privacy Policy"
          },
          forceMajeure: {
            title: "12. Force majeure",
            content: "The execution of the Seller's obligations is suspended in the event of the occurrence of a fortuitous case or force majeure that would prevent its execution. The Seller will notify the Buyer of the occurrence of such an event as soon as possible."
          },
          law: {
            title: "13. Applicable law and competent jurisdiction",
            content1: "These Terms are subject to French law. In case of dispute, French courts will have sole jurisdiction.",
            content2: "However, prior to any recourse to an arbitral or state judge, the Buyer is invited to contact the Seller's customer service to seek an amicable solution."
          },
          customerService: {
            title: "14. Customer service",
            content: "For any information, question or complaint, the customer can contact Alturion Labs customer service:",
            email: "By email: support@alturionlabs.com",
            phone: "By phone: +33 6 98 50 37 79",
            address: "Address: 39 Bd Maurice Pourchon, 63100 Clermont-Ferrand"
          }
        }
      },
      // Support page
      support: {
        hero: {
          title: "Support",
          description: "Our team is here to help you. Contact us for any questions about our indicators or your account."
        },
        contact: {
          title: "Contact us",
          description: "Fill out the form below and we will get back to you as soon as possible.",
          labels: {
            name: "Full name",
            email: "Email address",
            subject: "Subject",
            message: "Message"
          },
          placeholders: {
            name: "Your full name",
            email: "your.email@example.com",
            subject: "Subject of your request",
            message: "Describe your question or issue in detail..."
          },
          sendButton: "Send message",
          loading: "Sending...",
          validation: {
            required: "All fields are required",
            error: "Error sending message. Please try again later."
          }
        },
        faq: {
          title: "Frequently Asked Questions",
          description: "Find quick answers to the most common questions.",
          items: [
            {
              question: "How do I install my NinjaTrader indicators?",
              answer: "After your purchase, download the ZIP file from your profile. Open NinjaTrader 8, go to Tools > Import > NinjaScript Add-On, select the ZIP file and restart NinjaTrader."
            },
            {
              question: "How do I get my activation license?",
              answer: "Go to your profile, 'My Indicators' section, and click 'Get my license' for the relevant indicator. You will need to provide your signed NinjaTrader Machine ID."
            },
            {
              question: "What should I do if my indicator doesn't work?",
              answer: "First check that you have restarted NinjaTrader after installation. Also make sure you have the correct version of NinjaTrader (8.0 or higher). If the problem persists, contact our support."
            },
            {
              question: "Can I use my indicators on multiple computers?",
              answer: "Each license is tied to a specific Machine ID. To use your indicators on another computer, you will need to request a new license with that new computer's Machine ID."
            },
            {
              question: "How can I re-download my indicators?",
              answer: "You can download your indicators at any time from your profile, in the 'My Indicators' section. Download links remain active indefinitely."
            }
          ]
        }
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr,
      en
    },
    fallbackLng: 'en',
    supportedLngs: ['fr', 'en'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    debug: false,
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n; 